/* istanbul ignore file */
import { addressEdit, institutionsCoreSkip } from 'utils/FlowProvider/redirects'
import { FlowEntry, FlowRoute } from '../../types'
import {
  addressSuggestionContinue,
  bankLinkSuccessContinue,
  mapRegistrationRequirementsToRoute,
  plaidSuccessSkip,
} from './redirects'

export const plaidLayer: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Signup }],
    isFirstPage: true,
  },
  {
    page: FlowRoute.Signup,
    actions: [{ name: 'continue', goTo: () => FlowRoute.PhoneNumber }],
  },
  {
    page: FlowRoute.PhoneNumber,
    actions: [
      { name: 'cancel', goTo: () => FlowRoute.MFASetup },
      { name: 'error-personal-info', goTo: () => FlowRoute.PersonalInfo },
      { name: 'error-contact-info', goTo: () => FlowRoute.ContactInfo },
      { name: 'error-ssn', goTo: () => FlowRoute.SSN },
      { name: 'continue', goTo: () => FlowRoute.Funding },
      { name: 'resume', goTo: () => FlowRoute.PersonalInfo },
    ],
  },
  {
    page: FlowRoute.MFASetup,
    actions: [{ name: 'continue', goTo: () => FlowRoute.PersonalInfo }],
  },
  {
    page: FlowRoute.PersonalInfo,
    actions: [{ name: 'continue', goTo: () => FlowRoute.ContactInfo }],
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.SSN,
      },
      {
        name: 'choose',
        goTo: () => FlowRoute.AddressSuggestion,
      },
      {
        name: 'more_info',
        goTo: () => FlowRoute.AddressInvalid,
      },
    ],
  },
  {
    page: FlowRoute.SSN,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Funding }],
  },
  {
    page: FlowRoute.Funding,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.Institutions },
      { name: 'skip', goTo: plaidSuccessSkip },
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
    ],
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.PlaidLinkRedirect,
    actions: [
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      { name: 'instant', goTo: () => FlowRoute.Institutions },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [{ name: 'continue', goTo: bankLinkSuccessContinue }],
  },
  {
    page: FlowRoute.PricingInterstitial,
    actions: [{ name: 'continue', goTo: () => FlowRoute.SubscriptionActive }],
  },
  { page: FlowRoute.InvestInterstitial, actions: [] },
  {
    page: FlowRoute.SubscriptionActive,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.InvestInterstitial },
      { name: 'goBack', goTo: mapRegistrationRequirementsToRoute },
    ],
  },
  {
    page: FlowRoute.Success,
    actions: [],
  },
  {
    page: FlowRoute.HDYHAU,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Success }],
  },
  {
    page: FlowRoute.ProductOnboarding,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.HDYHAU },
      { name: 'later-onboarding', goTo: () => FlowRoute.LaterInterstitial },
    ],
  },
  { page: FlowRoute.LaterInterstitial, actions: [] },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [{ name: 'product-onboarding', goTo: () => FlowRoute.ProductOnboarding }],
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [{ name: 'product-onboarding', goTo: () => FlowRoute.ProductOnboarding }],
  },
  {
    page: FlowRoute.AddressInvalid,
    actions: [
      {
        name: 'continue',
        goTo: addressEdit,
      },
    ],
  },
  {
    page: FlowRoute.AddressSuggestion,
    actions: [
      {
        name: 'continue',
        goTo: addressSuggestionContinue,
      },
      {
        name: 'update',
        goTo: addressEdit,
      },
    ],
  },
]
